module.exports = __webpack_public_path__ + "static/media/list-ol.d36404a4.svg";